import React, {Component} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {toast} from 'react-toastify';

import ErrorMsg from "../common/ErrorMsg";
import StaffDashboardService from "../../services/StaffDasboardService";

export default class ClockOutModal extends Component {
    state = {
        reasons: [],
        selectedReason: {
            "clock_out_reason": 0
        }
    };

    componentDidMount = () => {
        this.getInitialState();
    };

    getInitialState = async () => {
        try {
            let result = await StaffDashboardService.getClockOutReasons();

            let reasons = [];
            if (200 === result.status) {
                reasons = result.data.reason;
            }
            this.setState({reasons});

        } catch (error) {
            toast.error(<ErrorMsg errors={error.response}/>, {autoClose: 5000});
        }
    };

    toggleModal = () => {
        this.setState({
            selectedReason: {
                "clock_out_reason": 0
            }
        }, () => this.props.toggleModal());
    };

    handleChange = (value) => {
        let selectedReason = {...this.state.selectedReason};
        selectedReason["clock_out_reason"] = value;
        this.setState({selectedReason});
    };

    submitClockOutReason = async () => {
        let {selectedReason} = this.state;
        if (selectedReason.clock_out_reason > 0) {
            try {
                const result = await this.props.putClockOut(selectedReason);
                if (result) {
                    this.toggleModal();
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        } else {
            toast.error("Please select reason then submit.");
        }
        return false;
    };

    render() {
        const {reasons, selectedReason} = this.state;
        let reasonsOptions = []
        reasons.map((reason, index) => {
            reasonsOptions.push( 
                <div key={index} className="custom-control custom-radio pl-0 pt-2">
                    <input type="radio" className="custom-control-input" value={reason.id} name="clock_out_reason" checked={this.state.selectedReason.clock_out_reason === reason.id} onChange={() => this.handleChange(reason.id)} />
                    <label className="custom-control-label" htmlFor="clock_out_reason" onClick={() => this.handleChange(reason.id)}>{reason.reason}</label>
                </div>
            )
        });
        
        return (
            <Modal isOpen={this.props.modal} toggle={this.toggleModal}>
                <ModalHeader toggle={this.toggleModal}>
                    Select Reason for Clock Out
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-sm-6">
                            <label className="mb-0">Select a Reason</label>
                            {reasonsOptions}
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button className='btn btn-success' onClick={this.submitClockOutReason}>Submit</Button>
                    <Button className='btn btn-secondary' onClick={this.toggleModal}>Cancel</Button>
                </ModalFooter>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/staffDashboard/ClockOutModal.js